import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';

import styles from './Paragraph.scss';

/**
 * @visibleName Paragraph ✏️
 */
const Paragraph = ({ children, fontSize, fontWeight, alignText, appearance, margin, ...props }) => {
  const classProps = classnames(
    styles.paragraph,
    styles[`paragraph-weight-${fontWeight}`],
    styles[`paragraph-size-${fontSize}`],
    styles[`paragraph-align-${alignText}`],
    styles[`paragraph-${appearance}`],
    props.className,
    { [styles['paragraph-no-margin']]: !margin }
  );

  return <p className={classProps}>{children}</p>;
};

Paragraph.defaultProps = {
  children: null,
  alignText: 'left',
  fontSize: 'md',
  fontWeight: 'normal',
  appearance: 'dark',
  margin: true,
};

Paragraph.propTypes = {
  /** The content to be rendered inside the p tag */
  children: PropTypes.any,
  /** The size of the text, defaults to md */
  fontSize: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  /** The Paragraph font weight. Must be one of the scss variables */
  fontWeight: PropTypes.oneOf(['light', 'normal', 'bold', 'extra-bold']),
  appearance: PropTypes.oneOf(['light', 'dark', 'form', 'white', 'error']),
  alignText: PropTypes.oneOf(['left', 'center', 'right']),
  margin: PropTypes.bool,
  style: PropTypes.any,
};

export default Paragraph;
